<template>
    <span class="form-group">
        <span class="text-danger">*</span>
    </span>
</template>

<script>
    export default {
       
    };

</script>

<style>
</style>
